import { render, staticRenderFns } from "./twoyearsInfo.vue?vue&type=template&id=4ac6b196&"
import script from "./twoyearsInfo.vue?vue&type=script&lang=js&"
export * from "./twoyearsInfo.vue?vue&type=script&lang=js&"
import style0 from "./twoyearsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports